import { JsonError, Model } from 'survey-core';

export const getSurveyJSModelErrors = (value: string): JsonError[] => {
  const { jsonErrors } = new Model(value);

  return jsonErrors ?? [];
};
